import MotorCycleHero from 'assets/images/psp/PSPHero/motorcycle-hero.webp';
import FaQHeadingIcon from 'assets/images/psp/Faq/StorageImage.svg';
import Unit5X5Icon from 'assets/images/psp/SizeGuide/motorcycle/5x5.svg';
import Unit5X10Icon from 'assets/images/psp/SizeGuide/motorcycle/5x10.svg';
import Unit5X15Icon from 'assets/images/psp/SizeGuide/motorcycle/5x15.svg';
import Unit10X10Icon from 'assets/images/psp/SizeGuide/motorcycle/10x10.svg';
import Unit10X15Icon from 'assets/images/psp/SizeGuide/motorcycle/10x15.svg';
import MotorCycleVideoImage from 'assets/images/psp/PSPVideo/motorcycle.png';
import MotorCycleSteps from 'assets/images/psp/PSPVideo/motorcycle-winterizing-steps.png';
import MotorcycleStorage from 'assets/images/psp/FeaturedContentImages/motorcycle-storage.jpg';
import Motorcycle from 'assets/images/psp/FeaturedContentImages/motorcycle.png';
import CarStorage1 from 'assets/images/psp/FeaturedContentImages/car-storage1.jpg';
import CarStorageGuide from 'assets/images/psp/FeaturedContentImages/car-storage-guide.jpg';

const metadata = {
	title: 'Find Motorcycle Storage Near You | SpareFoot',
	description:
		'Find the best Motorcycle storage near you. Discover the best Motorcycle storage nearby — view prices, photos, availability, and reviews for local facilities!',
};

const reviews = [
	{
		title: 'Evan Provided Great Customer Service',
		link: 'https://www.trustpilot.com/reviews/669fcb02e405d59061446523',
		stars: 5,
		text: 'Evan was really wonderful to work with. I have very little experience in rented storage space, and even less in renting a storage space for a motorcycle. Evan assisted in making sure I had the proper size and location.',
		customerName: 'Erin',
		date: 'Jul 23, 2024',
	},
	{
		title: 'It was a very nice and pleasant experience',
		link: 'https://www.trustpilot.com/reviews/5ee92e067dd7530708856a5c',
		stars: 5,
		text: 'It was a very nice and pleasant experience. Staff was very professional and helpful. Storage space was clean and just what was needed for parking my motorcycle. The price is very much right on queue with every one else, maybe even a few dollars cheaper than the rest.',
		customerName: 'Preston Newberry',
		date: 'Jun 17, 2020',
	},
	{
		title: 'Best 1st Impression',
		link: 'https://www.trustpilot.com/reviews/5daf9ec16048580988adc0f0',
		stars: 5,
		text: 'This site is awesome. I needed to store my motorcycle for the winter and of course, like most people I waited till the last minute to do so. spent a couple hours running around town only to find out that no one had available units. Jumped on selfstorage.com and found the perfect unit in minutes. Saved me a bunch of time and energy. Great site',
		customerName: 'Anthony Hainsworth',
		date: 'Oct 23, 2019',
	},
	{
		title: 'This site is awesome!',
		link: 'https://www.trustpilot.com/reviews/5bf444779d3780035820669e',
		stars: 5,
		text: 'this site is awesome. I needed to store my motorcycle for the winter and of course, like most people I waited till the last minute to do so. spent a couple hours running around town only to find out that no one had available units. jumped on selfstorage.com and found the perfect unit in minutes. Saved me a bunch of time and energy. great site',
		customerName: 'Ron Yoak',
		date: 'Nov 20, 2018',
	},
];

const motorcycleStorageFAQs = [
	{
		question: 'How do I find reliable motorcycle storage units near me?',
		answer: "Use **SelfStorage.com's** search tool to compare facilities in your area. Look for reviews, security features, and access hours that match your needs. Don't just choose the cheapest option—your motorcycle is an investment worth protecting properly.",
	},
	{
		question: 'Should I choose indoor or outdoor motorcycle storage?',
		answer: "Indoor storage offers maximum protection but costs more. Choose indoor for valuable, vintage, or pristine motorcycles. Outdoor covered storage works well for daily riders and budget-conscious storage needs. Consider your motorcycle's value, your budget, and local weather conditions.",
	},
	{
		question: 'What size storage unit do I need for my motorcycle?',
		answer: "Most standard motorcycles fit comfortably in a 5x10 unit with room for gear. Larger touring bikes or multiple motorcycles need 5x15 or 10x10 units. Measure your motorcycle's length and width, then add 2-3 feet on all sides for easy maneuvering.",
	},
	{
		question: 'How much does motorcycle storage cost per month?',
		answer: 'Prices vary by location and amenities, but expect $40-120/month depending on unit size and features. Climate control typically adds $15-40/month. Rural areas cost less than urban centers. Many facilities offer first-month specials or long-term discounts.',
	},
	{
		question: 'Do I need climate control for motorcycle winter storage?',
		answer: "Climate control isn't always necessary but is recommended for valuable motorcycles, vintage bikes, or areas with extreme temperature swings. It prevents condensation, protects rubber seals, and maintains stable conditions for long-term storage.",
	},
	{
		question: 'Can I access my motorcycle storage unit anytime?',
		answer: "Access hours vary by facility. Some offer 24/7 access, while others have specific hours. Consider when you'll need access—if you want to check on your bike or grab gear during off-hours, choose a facility with extended access.",
	},
	{
		question: 'What should I look for in motorcycle storage security?',
		answer: 'Essential security features include perimeter fencing, controlled gate access, adequate lighting, and surveillance cameras. Premium features like individual unit alarms and on-site personnel provide extra protection but increase costs.',
	},
	{
		question: 'How do I prepare my motorcycle for long-term storage?',
		answer: 'Key steps include cleaning thoroughly, changing oil, filling the gas tank with stabilizer, removing or maintaining the battery, checking tire pressure, and using a breathable cover. Proper preparation prevents costly damage during storage months. For a complete preparation checklist, download our PDF here.',
	},
];

export const MotorcycleStorageContent = {
	metadata,
	type: 'Motorcycle',
	reviews: reviews,
	sections: [
		{
			title: 'Motor Cycle Storage Hero',
			background: 'default',
			modules: [
				{
					type: 'hero',
					background: 'lighterYellow',
					props: {
						content: {
							title: 'Find Affordable Motorcycle Self Storage',
							description:
								"Worried about your motorcycle sitting exposed to the elements? Whether it's your daily commuter, weekend adventure bike, or that vintage Honda motorcycle you're restoring in your garage, finding the right motorcycle storage solution protects your investment and gives you peace of mind. From weatherproofing to security, motorcycle storage units offer the perfect solution for keeping your two-wheeler safe, accessible, and ready to ride when the season returns.\n\n**SelfStorage.com** makes it easy to find and reserve the perfect motorcycle storage unit close to home—because your bike deserves better than a corner of the garage next to the holiday decorations.",
							image: MotorCycleHero,
							CTAtext: 'Find Motorcycle Self Storage',
						},
					},
				},
			],
		},
		{
			title: 'unit size chart 1',
			modules: [
				{
					type: 'cardStrip',
					props: {
						heading: 'Motorcycle Storage Unit Size Guide',
						cardData: [
							{
								title: '5x5',
								content:
									'*Compact and budget-friendly for smaller rides and urban commuters*\n\n' +
									'**Perfect for:** Scooters, Small motorcycles (under 250cc), Electric bikes\n\n' +
									'**Average Price:** $25-45/mo.\n\n' +
									'**Climate-Control Add-on:** +$10-20/mo.',
								imageSrc: Unit5X5Icon,
								contentAlign: 'text-left',
							},
							{
								title: '5x10',
								content:
									'*Ideal for most motorcycles with room for gear and maintenance supplies*\n\n' +
									'**Perfect for:** Standard motorcycles, sport bikes, cruisers\n\n' +
									'**Average Price:** $40-70/mo.\n\n' +
									'**Climate-Control Add-on:** +$15-25/mo.',
								imageSrc: Unit5X10Icon,
								contentAlign: 'text-left',
							},
							{
								title: '5x15',
								content:
									'*Extra space for larger motorcycles plus all your riding accessories*\n\n' +
									'**Perfect for:** Large motorcycles with sidecars, multiple helmets & gear\n\n' +
									'**Average Price:** $55-90/mo.\n\n' +
									'**Climate-Control Add-on:** +$20-30/mo.',
								imageSrc: Unit5X15Icon,
								contentAlign: 'text-left',
							},
							{
								title: '10x10',
								content:
									'*Room for multiple motorcycles or one with a complete maintenance station*\n\n' +
									'**Perfect for:** Multiple motorcycles, motorcycle + ATV, workshop setup\n\n' +
									'**Average Price:** $75-120/mo.\n\n' +
									'**Climate-Control Add-on:** +$25-40/mo.',
								imageSrc: Unit10X10Icon,
								contentAlign: 'text-left',
							},
							{
								title: '10x15',
								content:
									'*Maximum space for multiple motorcycles with room to move around safely*\n\n' +
									'**Perfect for:** 2-3 motorcycles, family bike collection, dealer storage\n\n' +
									'**Average Price:** $95-150/mo.\n\n' +
									'**Climate-Control Add-on:** +$30-45/mo.',
								imageSrc: Unit10X15Icon,
								contentAlign: 'text-left',
							},
						],
					},
				},
			],
		},

		{
			title: 'video content 1',
			background: 'blueGradient',
			modules: [
				{
					title: 'Motorcycle Storage Options',
					type: 'video',
					props: {
						content: {
							title: 'Understanding Your Motorcycle Storage Options',
							imageSrc: MotorCycleVideoImage,
							suffixText:
								'Indoor Storage Units provide complete protection from weather, theft, and vandalism. Your motorcycle stays in a temperature-controlled environment, perfect for winter motorcycle storage or long-term storage.\n\n ' +
								'Outdoor Storage Units are budget-friendly options that still offer security and basic weather protection.\n\n' +
								'Covered Storage combines the best of both worlds—protection from rain, snow, and UV rays while remaining more affordable than indoor options.',
						},
					},
				},
			],
		},

		{
			title: 'content section',
			background: 'white',
			modules: [
				{
					title: 'Protecting Your Investment',
					type: 'content',
					props: {
						title: 'Protecting Your Investment: Security Options Explained',
						contentType: 'row-type',
						theme: 'light',
						content: [
							'Motorcycle theft is a real concern—especially for popular models. That’s why security should be your top priority when choosing a storage unit for your motorcycle.\n\n' +
								'Look for facilities with multiple security layers: perimeter fencing, controlled gate access, well-lit areas, and surveillance cameras. \n\n' +
								'Many modern storage facilities offer premium security features like individual unit alarms and 24/7 monitoring.\n\n' +
								"While these add-ons increase your monthly cost, they're worth considering if you're storing a high-value bike or live in a susceptible area.\n\n" +
								'You might be able to score discounts for storing your motorcycle long-term in a secure facility.',
						],
					},
				},
			],
		},

		{
			title: 'video content 2',
			noPaddingBottom: true,
			background: 'blueGradient',
			modules: [
				{
					title: 'Winterizing Your Motorcycle',
					type: 'video',
					props: {
						content: {
							title: 'Winterizing Your Motorcycle: The Complete Guide',
							description:
								"Proper winterization is crucial, whether you're using indoor climate controlled storage or outdoor units. Skip these steps, and you could face expensive repairs come spring—carburetor cleaning alone can cost $200-400, while neglected tires might need a complete replacement.",
							imageSrc: MotorCycleSteps,
						},
					},
				},
			],
		},

		{
			title: 'Reviews Section',
			noPaddingTop: true,
			background: 'lighterBlue',
			modules: [
				{
					type: 'reviews',
					props: {
						reviewsData: {
							headerTitle: 'Motorcycle Self Storage: ',
							reviews: reviews,
						},
					},
				},
			],
		},

		{
			title: 'FAQ Section',
			modules: [
				{
					type: 'faqs',
					props: {
						content: {
							header: 'Motorcycle Self Storage FAQ',
							image: FaQHeadingIcon,
							faqs: motorcycleStorageFAQs,
						},
					},
				},
			],
		},
		{
			title: 'featured content',
			background: 'darkBlue',
			modules: [
				{
					type: 'featuredContent',
					props: {
						data: {
							heading: 'Learn All About Motorcycle Self Storage',
							slug: 'motorcycle-featured-content',
							data: {
								unitCards: [
									{
										title: 'Storage Tips',
										url: 'https://www.selfstorage.com/blog/guide-to-motorcycle-winter-storage/',
										date: 'October 5, 2025',
										image: MotorcycleStorage,
										content:
											'Quick Guide to Proper Motorcycle Winter Storage',
									},
									{
										title: 'Storage Tips',
										url: 'https://www.selfstorage.com/blog/small-vehicle-storage-guide/',
										date: 'October 16, 2025',
										image: Motorcycle,
										content:
											'Small Vehicle Storage: How to Store Motorcycles, ATVs, and Golf Carts',
									},
									{
										title: 'Storage Tips',
										url: 'https://www.selfstorage.com/blog/how-to-store-a-car/',
										date: 'June 5, 2025',
										image: CarStorage1,
										content:
											'Car Storage Tips: Short-Term and Long-Term Storage',
									},
									{
										title: 'Storage Tips',
										url: 'https://www.selfstorage.com/blog/car-storage-size-guide/',
										date: 'March 3, 2025',
										image: CarStorageGuide,
										content:
											'Choosing the Right Storage Unit for Your Vehicle',
									},
								],
							},
						},
					},
				},
			],
		},
		{
			title: 'Link to other PSPs',
			background: 'lighterBlue',
			modules: [
				{
					type: 'links',
					props: {
						heading: {
							headingName: 'More ways to store',
						},
						id: 'storage size unit cards',
						linksList: ['vehicle', 'atv', 'dirtBike', 'car'],
					},
				},
			],
		},

		{
			title: 'nearby units',
			modules: [
				{
					type: 'storageNearYou',
					props: {
						type: 'Motorcycle',
					},
				},
			],
		},
	],
};
